export default "__VITE_ASSET__qWL6dmuP__"